module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/020-iraq-c9fd75dd26b6d550637319fd59d3d9cc.svg";